import { useFormatters, useI18n } from '../../i18n';
import type { ClusterInfo } from './mapData';

/** Which cluster is which colour, how big it is, and what is in it. */
export function ClusterLegend({ clusters }: { clusters: readonly ClusterInfo[] }) {
  const { t, locale } = useI18n();
  const fmt = useFormatters();
  // The Chinese enumeration comma is wrong in English and vice versa.
  const separator = locale === 'en' ? ', ' : '、';

  if (clusters.length === 0 || (clusters.length === 1 && clusters[0]?.cluster === 0)) {
    return <p className="aside__empty">{t('result.legend.none')}</p>;
  }

  return (
    <div className="legend">
      {clusters.map((info) => (
        <div key={info.cluster}>
          <div className="legend__row">
            <span className="legend__swatch" style={{ background: info.color }} aria-hidden />
            <span className="legend__label">
              {t('result.legend.cluster', { n: info.cluster || '—' })}
            </span>
            <span className="legend__count">
              {t('result.legend.count', { n: fmt.int(info.count) })}
            </span>
          </div>
          {info.examples.length > 0 ? (
            <p className="legend__examples">{info.examples.join(separator)}</p>
          ) : null}
        </div>
      ))}
    </div>
  );
}
